import { ICalendarEventsData } from '@common/interfaces/calendar'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { ILoadingData } from '../types'
import * as actions from './actions'

export interface ICalendarState {
  loadingArray: string[]
  events: ILoadingData<ICalendarEventsData>
}

export default combineReducers({
  loadingArray: loadingArrayReducer([actions.prefix]),
  events: createLoadingDataReducer<ICalendarEventsData>([actions.LIST_CALENDAR_EVENTS_REQUEST]),
})
